import { useEffect, useState } from "react";
import { Search, Loader2, Droplets, Plus } from "lucide-react";
import api from "@/lib/api";

// Búsqueda de PACKs en el servidor (catálogo de +20k SKUs): nunca carga todo el catálogo en el navegador
export default function ProductoBuscador({ onSelect, placeholder = "Buscar PACK por SKU, nombre o código…", testId = "producto-buscador", autoFocus = false, renderExtra, className = "", limite = 30 }) {
  const [q, setQ] = useState("");
  const [res, setRes] = useState([]);
  const [buscando, setBuscando] = useState(false);

  useEffect(() => {
    const term = q.trim();
    if (term.length < 2) { setRes([]); setBuscando(false); return undefined; }
    setBuscando(true);
    const t = setTimeout(async () => {
      try { const { data } = await api.get("/productos/buscar", { params: { q: term } }); setRes(data); } catch { setRes([]); } finally { setBuscando(false); }
    }, 220);
    return () => clearTimeout(t);
  }, [q]);

  function elegir(p) { onSelect(p); setQ(""); setRes([]); }

  return (
    <div className={className} data-testid={testId}>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3.5 top-3.5 text-brand-muted" />
        <input data-testid={`${testId}-input`} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); if (res[0]) elegir(res[0]); } }} placeholder={placeholder} className="field h-11 pl-10 pr-9" autoFocus={autoFocus} />
        {buscando && <Loader2 className="w-4 h-4 absolute right-3 top-3.5 animate-spin text-brand-muted" />}
      </div>
      {res.length > 0 && (
        <div className="mt-1.5 max-h-64 overflow-y-auto scrollbar-thin space-y-1" data-testid={`${testId}-resultados`}>
          {res.slice(0, limite).map((p) => (
            <button type="button" key={p.id} data-testid={`${testId}-item-${p.sku}`} onClick={() => elegir(p)} className="w-full flex items-center gap-3 bg-white border border-brand-line rounded-xl px-3 py-2 text-left hover:border-brand-amber hover:bg-brand-amber-soft/40 transition-[border-color,background-color] duration-100 animate-pop">
              <div className="w-9 h-9 rounded-lg bg-brand-surface overflow-hidden shrink-0 flex items-center justify-center">{p.foto_url ? <img src={p.foto_url} alt="" className="w-full h-full object-cover" loading="lazy" /> : <Droplets className="w-4 h-4 text-brand-line" />}</div>
              <div className="flex-1 min-w-0"><div className="text-sm font-semibold text-brand-ink truncate">{p.nombre}</div><div className="font-mono text-[10px] uppercase tracking-wider text-brand-muted">{p.sku} · {p.presentacion}{p.concentracion ? ` · ${p.concentracion}` : ""}</div></div>
              {renderExtra ? renderExtra(p) : <span className="font-mono text-xs font-bold text-brand-ink">${(p.precios?.propia || 0).toFixed(2)}</span>}
              <Plus className="w-4 h-4 text-brand-amber-dark shrink-0" />
            </button>
          ))}
        </div>
      )}
      {q.trim().length >= 2 && !buscando && res.length === 0 && <p className="text-xs text-brand-muted mt-2" data-testid={`${testId}-vacio`}>Sin coincidencias para “{q}”.</p>}
    </div>
  );
}
